import { useEvent, useStore } from 'effector-react'
import {
    $isNotShipmentSelected,
    $modalBasketDemand,
    $selectedForBasketGood,
    addBasketHandler,
    resetSelectedBasket
} from 'src/features/add-basket/model'

export const useModalDemand = () => useStore($modalBasketDemand)
export const useNotShipmentSelected = () => useStore($isNotShipmentSelected)
export const useSelectedBasketGood = () => useStore($selectedForBasketGood)
export const useResetSelectedGood = () => useEvent(resetSelectedBasket)
export const useAddBasketHandler = () => useEvent(addBasketHandler)
